import { axiosClient } from "./apiClient";

export function signIn(data){
    return axiosClient.post('/Donor/auth/Login', data);
}

export function signUp(data){
    return axiosClient.post('/Donor/auth/Signup', data);
}

export function verifyOtp(data){
    return axiosClient.post('/Donor/auth/VerifyOtp', data);
}

export function resendOtp(data){
    return axiosClient.post('/Donor/auth/ResendOtp', data);
}


export function forgotPassword(data){
    return axiosClient.post('/Donor/auth/Forgot_Password', data);
}

export function newPassword(data){
    return axiosClient.post('/Donor/auth/NewPassword', data);
}

export function changePassword(data){
    return axiosClient.post('/Donor/auth/ChangePassword', data);
}

export function getProfile(data){
    return axiosClient.post('/Donor/auth/userDetails', data);
}
export function dashboard(data){
    return axiosClient.post('/Donor/auth/userDetails', data);
}

export function DonorDetailsAPI(data){
    return axiosClient.post('/Donor/auth/userDetails', data);
}
export function UpdateDonorDetailsAPI(data){
    return axiosClient.post('/Donor/auth/EditProfile', data);
}

export function addCredit(data) {
  return axiosClient.post(`/Donor/wallet/add_to_wallet`, data);
}

export function generateSessionToken(data){
    return axiosClient.post('/Parent/order/getConvergeSessionToken', data);
}

export function walletTransactionList(data) {
  return axiosClient.post(`/Donor/wallet/wallet_transaction_list`, data);
}
export function sendPromocodeEmail(data) {
    return axiosClient.post('/School/auth/send_promocode_email', data);
}

export function SchoolListAPI(data) {
    return axiosClient.post('/Admin/school/school_list', data);
}

export function getParentListAPI(data){
    return axiosClient.post('/Admin/parents/list',data);
}

export function revokePromocodeAPI(data){
    return axiosClient.post('/Promocode/promocode_management/revoke_promocode', data);
}

export function deletePromocode(data){
    return axiosClient.post('/Promocode/promocode_management/delete_promocode', data);
}

export function promocodeListAPI(data){
    return axiosClient.post('/Promocode/promocode_management/list_promocode', data);
}

export function upsertPromocode(data){
    return axiosClient.post('/Promocode/promocode_management/upsert_promocode', data);
}

export function UpdateStatusPromocodeAPI(data){
    return axiosClient.post('/Promocode/promocode_management/status_promocode', data);
}

export function promocodeUsage(data){
    return axiosClient.post('/Promocode/promocode_management/promocode_usage', data);
}

export function MasterSchoolBoardListAPI(data) {
    return axiosClient.post('/Admin/master_school/school_board_list', data);
}

export function TransferToSchoolWalletAPI(data) {
    return axiosClient.post('/Donor/wallet/transfers_to_school_wallet', data);
}

export function CityListAPI(data) {
    return axiosClient.post('/Admin/city/list', data);
}

export function DonorAuthenticate(data){
    return axiosClient.post('/Donor/auth/donor_authenticate', data);
}